export const CFQ_STORAGE_KEY = 'cfq_assessment_state';
export const CFQ_SESSION_EXPIRY = 24 * 60 * 60 * 1000;

export const domains = [
  {
    name: 'Self-Anchoring',
    subtitle: 'Identity & Integrity',
    statements: [
      'I can adapt my behaviour without feeling I\'m betraying who I am.',
      'I am clear about the core values I will not compromise.',
      'Feedback from other cultures makes me reflective, not defensive.',
      'I know how to stay authentic while being flexible in different environments.',
      'My identity remains grounded even in unfamiliar settings.'
    ]
  },
  {
    name: 'Perspective-Shifting',
    subtitle: 'Empathy & Understanding',
    statements: [
      'I seek to understand why others act differently before judging.',
      'I recognise when I interpret people through my cultural lens.',
      'I value perspectives that challenge my assumptions.',
      'I actively learn from people with different worldviews.',
      'I can see issues from more than one cultural viewpoint.'
    ]
  },
  {
    name: 'Adaptive Communication',
    subtitle: 'Expression & Context',
    statements: [
      'I adjust my tone or style when speaking with people from different backgrounds.',
      'I am aware of unspoken cues in cross-cultural communication.',
      'I clarify misunderstandings before they grow into conflict.',
      'I know when direct communication may be seen as disrespectful.',
      'I express ideas clearly without imposing my own cultural style.'
    ]
  },
  {
    name: 'Relational Integration',
    subtitle: 'Collaboration & Influence',
    statements: [
      'I create spaces where everyone\'s voice is valued.',
      'I build trust even when values or styles differ.',
      'I thrive in multicultural teams that embrace diversity.',
      'I lead or collaborate in ways that unite rather than divide.',
      'I intentionally bridge gaps between groups or individuals.'
    ]
  }
];

export const scaleLabels = [
  { value: 1, label: 'Rarely' },
  { value: 2, label: 'Sometimes' },
  { value: 3, label: 'Often' },
  { value: 4, label: 'Usually' },
  { value: 5, label: 'Consistently' }
];
